import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/common.json";
import enAp from "./locales/en/ap.json";
import enAr from "./locales/en/ar.json";
import enFinancing from "./locales/en/financing.json";
import enReminders from "./locales/en/reminders.json";
import enTasks from "./locales/en/tasks.json";
import enReports from "./locales/en/reports.json";
import enAutomations from "./locales/en/automations.json";
import enDashboard from "./locales/en/dashboard.json";

import arAr from "./locales/ar/ar.json";

import es from "./locales/es/common.json";
import esAp from "./locales/es/ap.json";
import esAr from "./locales/es/ar.json";
import esFinancing from "./locales/es/financing.json";
import esReminders from "./locales/es/reminders.json";
import esTasks from "./locales/es/tasks.json";
import esReports from "./locales/es/reports.json";
import esAutomations from "./locales/es/automations.json";
import esDashboard from "./locales/es/dashboard.json";

const resources = {
  en: {
    common: en,
    ap: enAp,
    ar: enAr,
    financing: enFinancing,
    reminders: enReminders,
    tasks: enTasks,
    reports: enReports,
    automations: enAutomations,
    dashboard: enDashboard,
  },
  ar: {
    ar: arAr,
  },
  es: {
    common: es,
    ap: esAp,
    ar: esAr,
    financing: esFinancing,
    reminders: esReminders,
    tasks: esTasks,
    reports: esReports,
    automations: esAutomations,
    dashboard: esDashboard,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "ap", "ar", "financing", "reminders", "tasks", "reports", "automations", "dashboard"],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "octa-locale",
    },
  });

export default i18n;
